import { SymptomLike } from '../diagnoses/symptom';

/**
 * A symptom item in a public search query.
 */
export class SymptomItem {
  public readonly symptom: SymptomLike;
  public readonly isHighlighted: boolean;

  constructor({
    symptom,
    isHighlighted = false
  }: {
    symptom: SymptomLike;
    isHighlighted?: boolean;
  }) {
    this.symptom = symptom;
    this.isHighlighted = isHighlighted;
  }

  copyWith({
    symptom = undefined,
    isHighlighted = undefined
  }: {
    symptom?: SymptomLike;
    isHighlighted?: boolean;
  }) {
    return new SymptomItem({
      symptom: symptom ?? this.symptom,
      isHighlighted: isHighlighted ?? this.isHighlighted
    });
  }

  toJson(): any {
    return {
      symptom: this.symptom.toJson(),
      is_highlighted: this.isHighlighted
    };
  }
}
